import React from 'react';
import { List, Datagrid, Filter, ReferenceField, TextField, TextInput } from 'react-admin';

const GradeFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const GradeList = props => (
  <List filters={<GradeFilter />} {...props} exporter={false}>
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <ReferenceField source="parentId" reference="schools" allowEmpty>
        <TextField source="name" />
      </ReferenceField>
    </Datagrid>
</List>
);

export default GradeList
